import React from 'react';
import { Link, Redirect } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { needsAuth } from './utils/authHoc';
import { hasCourseAccess } from '../actions/utils';
import { getTinkercadLessonById } from '../data/tinkercad-course';

import './tinkercad-lesson-view.scss';

const TinkercadLessonView = ({ lesson, lessonId, hasAccess }) => {
  if (!hasAccess) {
    return <Redirect to="/i/plan" />;
  }

  if (!lesson) {
    return (
      <div className="tinkercad-lesson-view tinkercad-lesson-view--missing">
        <p>Урок не найден.</p>
        <Link to="/i/tinkercad" className="tinkercad-lesson-view__back">
          К списку уроков
        </Link>
      </div>
    );
  }

  return (
    <div className="tinkercad-lesson-view">
      <div className="tinkercad-lesson-view__toolbar">
        <Link to="/i/tinkercad" className="tinkercad-lesson-view__back">
          <i className="fa fa-angle-left" aria-hidden="true" />
          К списку уроков
        </Link>
        <div className="tinkercad-lesson-view__meta">
          <span className="tinkercad-lesson-view__number">Урок {lessonId}</span>
          <span className="tinkercad-lesson-view__title">{lesson.title}</span>
        </div>
      </div>
      <iframe
        className="tinkercad-lesson-view__frame"
        title={lesson.title}
        src={`/tinkercad-lessons/${lesson.file}`}
      />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const lessonId = ownProps.params.lessonId;
  const { user } = state.auth;

  return {
    lessonId,
    lesson: getTinkercadLessonById(lessonId),
    hasAccess: user && hasCourseAccess(user),
  };
};

export default compose(needsAuth, connect(mapStateToProps))(TinkercadLessonView);
